import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles,
  Tooltip,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fullWidth?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg';
  minWidth?: string | number;
  onClose(): void;
  open: boolean;
  userCanClose?: boolean;
}

export const SimpleDialog = (props: Props) => {
  const {
    children,
    fullWidth,
    maxWidth,
    minWidth,
    onClose,
    open,
    userCanClose = true,
  } = props;
  const classes = useStyles(minWidth ?? 200)();

  return (
    <Dialog
      className={classes.dialog}
      fullWidth={fullWidth ? fullWidth : false}
      maxWidth={maxWidth}
      onClick={(event) => event.stopPropagation()}
      onClose={onClose}
      open={open}
      disableEnforceFocus
    >
      {userCanClose ? (
        <DialogTitle className={classes.title}>
          <Tooltip title="Close">
            <IconButton
              className={classes.closeIcon}
              onClick={onClose}
              size="small"
            >
              <Close />
            </IconButton>
          </Tooltip>
        </DialogTitle>
      ) : null}
      <DialogContent className={classes.content}>{children}</DialogContent>
    </Dialog>
  );
};

const useStyles = (minWidth: string | number) =>
  makeStyles((theme: any) => {
    return {
      closeIcon: {
        color: 'white',
        float: 'right',
        position: 'relative',
        top: -2,
        width: 40,
        height: 40,
        marginLeft: 'auto',
        padding: theme.spacing(1),
      },
      content: {
        padding: 15,
        minWidth: minWidth,
      },
      dialog: {
        backdropFilter: 'blur(2px)',
        '& .MuiDialog-root': {
          '&: hover': {
            backdropFilter: 'blur(0px)',
          },
        },
      },
      title: {
        padding: 2,
        backgroundColor: theme.palette.paper.dark,
      },
    };
  });
